module.exports = __webpack_public_path__ + "static/media/stm-21st-desktop-2440x300-@1x.0006aacc.webp";